module.exports = __webpack_public_path__ + "img/gps.436b7cb6.svg";